import { Component } from '@angular/core';

@Component({
  selector: 'frontend-header-back-btn',
  templateUrl: './header-back-btn.component.html',
  styleUrls: ['./header-back-btn.component.scss'],
  standalone: false
})
export class HeaderBackBtnComponent {}
